/* eslint-disable no-console */
import React, { useState, useEffect, useCallback } from 'react'

import axios from 'axios'
import { bool } from 'prop-types'

import isAxiosCancelOrNetworkError from 'Utils/isAxiosCancelOrNetworkError'

import EarningsContainer from './Components/EarningsContainer'
import ModelsContainer from './Components/ModelsContainer'
import ReputationContainer from './Components/ReputationContainer'

function MyStatistics({ showEarningsChart = false }) {
  const [data, setData] = useState({})
  const [earningsScope, setEarningsScope] = useState(6)
  const [isDataFetched, setIsDataFetched] = useState(false)
  const [axiosSource] = useState(axios.CancelToken.source())

  const onFetchSuccess = useCallback((response) => {
    setData(response.data)
    setIsDataFetched(true)
  }, [])

  const fetchData = useCallback(
    (monthsCount) => {
      return axios
        .get('/api/internal/seller_dashboard/profile', {
          params: { months_count: monthsCount },
          cancelToken: axiosSource.token,
        })
        .then((response) => onFetchSuccess(response))
        .catch((error) => {
          if (!isAxiosCancelOrNetworkError(error)) {
            console.log(error)
            window.Sentry.captureException(error, { extra: window.location })
          }
        })
    },
    [axiosSource, onFetchSuccess]
  )

  const onSortChange = useCallback(
    (dataResult) => {
      setEarningsScope(dataResult.value)
      setIsDataFetched(false)
      fetchData(dataResult.value)
    },
    [fetchData]
  )

  useEffect(() => {
    fetchData(earningsScope)

    return () => {
      axiosSource.cancel()
    }
  }, [])

  return (
    <div className="row">
      <div className="col-12 col-xl-10 offset-xl-1">
        <h2 className="content-heading__h2">My Statistics</h2>
      </div>
      {showEarningsChart && (
        <div className="col-12 col-lg-6 offset-xl-1">
          <EarningsContainer
            isDataFetched={isDataFetched}
            data={data}
            earningsScope={earningsScope}
            onSortChange={onSortChange}
          />
        </div>
      )}
      <div className="col-12 col-sm-6 col-lg-3 col-xl-2">
        <ModelsContainer isDataFetched={isDataFetched} data={data} />
      </div>
      <div className="col-12 col-sm-6 col-lg-3 col-xl-2">
        <ReputationContainer isDataFetched={isDataFetched} data={data} />
      </div>
      <div className="col-12 col-xl-10 offset-xl-1">
        <hr className="dashboard-statistics-hr" />
      </div>
    </div>
  )
}

MyStatistics.propTypes = {
  showEarningsChart: bool,
}

export default MyStatistics
